module.exports = __webpack_public_path__ + "static/media/aiva_social_image.aa806f71.png";